import React from "react";
import { useTranslation } from "react-i18next";

import style from "./styles.module.scss";

const keyI18n = "translations.admin.home";

interface Props {
  name: string;
}

export default function AdminHome({ name }: Props) {
  const { t } = useTranslation();

  return (
    <section className={style.card}>
      <h1 className={`pgm-headline-small ${style.title}`}>{t(`${keyI18n}.welcome`, { name })}</h1>
      <p className={`pgm-body-large ${style.subtitle}`}>{t(`${keyI18n}.subtitle`)}</p>
    </section>
  );
}
